import React from "react";
import { makeStyles } from "@mui/styles";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { Typography } from "../components/Typography";
import mbaimage from "../asset/mba_intro_img.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    height: "100vh",
    minHeight: 755,
    justifyContent: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxHeight: 1390,
      borderTop: "none",
      marginTop: 30,
    },
  },
  container1: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: 444,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
    },
  },
  topTextBox: {
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginLeft: 50,
    },
  },
  textBox1: {
    width: 629,
    alignSelf: "center",
    position: "relative",
    marginTop: 20,
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px 0px 20px 0px",
      textAlign: "justify",
    },
  },
  subtextBox: {
    width: 629,
    wordBreak: "keep-all",
    textAlign: "justify",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      margin: "0px 20px",
      width: "auto",
    },
  },
  imgBox: {
    height: 130,
    background: "#fdf5fd",
    display: "flex",
    justifyContent: "center",
  },
  img: {
    width: 372,
    height: 335,
    marginBottom: "55px",
    marginTop: "55px",
    position: "relative",
    bottom: 300,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      bottom: 145,
      width: 220,
      height: 195,
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 20,
    },
  },
}));

const MbaIntroPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.textBox1}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            사업소개
          </Typography>
        </div>
        <div className={classes.container1}>
          <div className={classes.subtextBox}>
            <Typography variant="mbaContent">
              다가오는 미래는 간호사에게 병원 뿐 아니라 지역사회 기반의 다양한
              간호조직인 노인요양원, 재가간호센터 공동생활가정, premium
              assistant living 등에서 확대된 역할을 요구하고 있다. 이러한 사회적
              요구에 부응하는 간호사가 되기 위해 간호경영자로서의 조직경영의
              안목과 역량을 갖추어야 한다. 간호창업자로서 조직을 이끌어 나가고,
              의사결정을 내리며, 비전과 전략을 수립해 가는 간호 경영자의
              첫걸음을 위한 간호 경영 교육 콘텐츠를 제공한다.
            </Typography>
          </div>
        </div>
        <div
          className={classes.imgBox}
          style={{
            position: "relative",
            marginTop: 50,
            textAlign: "center",
            marginBottom: 50,
          }}
        >
          <img src={mbaimage} alt="MBA" className={classes.img}></img>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default MbaIntroPage;
